export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_350.8b5a1327.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};